/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelStatetaxLookupModel.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/statetax-lookup-model";

export class AutogenModelStatetaxLookupModel<RowType extends ModelRow> extends Endpoint<RowType, RowStatetaxLookupModelFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowStatetaxLookupModel extends ModelRow<RowStatetaxLookupModelFields> {
	constructor(values?: Partial<RowStatetaxLookupModelFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowStatetaxLookupModelFields {
	allowance_type: string;
	bonus_tax_rate: number;
	company_id: string;
	deduct_fed: string;
	deduct_fica: string;
	descr: string;
	employee_max_sui: number;
	employee_max_sui_c: string;
	employee_max_sui_d: Date;
	employee_max_sui_n: number;
	employee_max_sui_r: number;
	employer_ett_pct: number;
	employer_id: string;
	employer_max_ett: number;
	employer_max_ett_c: string;
	employer_max_ett_d: Date;
	employer_max_ett_n: number;
	employer_max_ett_r: number;
	employer_max_sui: number;
	employer_max_sui_c: string;
	employer_max_sui_d: Date;
	employer_max_sui_n: number;
	employer_max_sui_r: number;
	employer_sdi_aux: number;
	employer_sui_pct: number;
	ett_exp_glid: string;
	ett_liab_glid: string;
	id: string;
	mag_media_code: string;
	max_adj_married: number;
	max_adj_married_c: string;
	max_adj_married_d: Date;
	max_adj_married_n: number;
	max_adj_married_r: number;
	max_adj_single: number;
	max_adj_single_c: string;
	max_adj_single_d: Date;
	max_adj_single_n: number;
	max_adj_single_r: number;
	max_employer_sdi: number;
	max_employer_sdi_c: string;
	max_employer_sdi_d: Date;
	max_employer_sdi_n: number;
	max_employer_sdi_r: number;
	max_fica_wages: number;
	max_fica_wages_c: string;
	max_fica_wages_d: Date;
	max_fica_wages_n: number;
	max_fica_wages_r: number;
	max_sdi: number;
	max_sdi_c: string;
	max_sdi_d: Date;
	max_sdi_n: number;
	max_sdi_r: number;
	max_sui_wages: number;
	max_sui_wages_c: string;
	max_sui_wages_d: Date;
	max_sui_wages_n: number;
	max_sui_wages_r: number;
	payee_sdi_pct: number;
	payee_sui_pct: number;
	sdi_exp_glid: string;
	sdi_liab_glid: string;
	std_adj_pct: number;
	sui_exp_glid: string;
	sui_liab_glid: string;
	tax_calc_method: string;
	tax_table_employer_sdi: string;
	tax_table_ett: string;
	tax_table_income: string;
	tax_table_payee_sui: string;
	tax_table_sdi: string;
	tax_table_unemployment: string;
	tax_wh_glid: string;
	type_of: string;
	use_auto_tax_table: string;
	wh_allow_amt: number;
	wh_allow_amt_c: string;
	wh_allow_amt_d: Date;
	wh_allow_amt_n: number;
	wh_allow_amt_r: number;
}

